export enum OrderStateChangeEnum {
    NoChange,
    AccountChange,
    OrderTemplateChange,
    QuotationChange,
    ContractChange
}
